import { render, staticRenderFns } from "./stockBaseSummary.vue?vue&type=template&id=446ef0a3&scoped=true&"
import script from "./stockBaseSummary.vue?vue&type=script&lang=js&"
export * from "./stockBaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./stockBaseSummary.vue?vue&type=style&index=0&id=446ef0a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ef0a3",
  null
  
)

export default component.exports